module.exports = __webpack_public_path__ + "img/sticker-en25x25.e7ae838e.jpg";